import type { CategorizationRule, KeywordMapping } from '../types';

export const RULES: CategorizationRule[] = [
  {
    category: "Housing",
    keywords: [
      "home depot",
      "lowes",
      "menards",
      "ace hardware",
      "true value",
      "septic",
      "grove collaborative",
    ],
  },
  {
    category: "Lawn & Garden",
    keywords: [
      "lawn care",
      "landscaping",
      "yard service",
      "lawn service",
      "garden center",
      "nursery",
      "lawn mower",
      "tree service",
      "lawn equipment",
      "mulch",
      "fertilizer",
      "weed control",
      "irrigation",
      "sod",
      "seed",
      "plants",
      "growing place",
    ],
  },
];

export const DISPLAY_NAMES: KeywordMapping[] = [
  { keyword: "home depot", displayName: "Home Depot" },
  { keyword: "lowes", displayName: "Lowe's" },
  { keyword: "menards", displayName: "Menards" },
  { keyword: "ace hardware", displayName: "Ace Hardware" },
];
